// Chakra imports
import { Box, Flex, Text, useColorModeValue, Skeleton } from "@chakra-ui/react";
// Custom components
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import React from "react";

const GlobalStats = ({ title, percentage, chart }) => {
  const textColor = useColorModeValue("gray.700", "white");
  return (
    <Card p='28px 10px 16px 0px' mb={{ sm: "26px", lg: "0px" }}>
      <CardHeader mb='20px' pl='22px'>
        <Flex direction='column' alignSelf='flex-start'>
          <Text fontSize='lg' color={textColor} fontWeight='bold' mb='6px'>
            {title}
          </Text>
          <Text fontSize='md' fontWeight='medium' color='gray.400'>
          <Skeleton height={"20px"} width={percentage ? null : "50%"} isLoaded={percentage || percentage == 0}>
              <Text
                as="span"
                color={percentage > 0 ? "green.400" : "red.500"}
                fontWeight="bold"
              >
                {percentage > 0 && "+"}
                {`${percentage}`}
              </Text>{" "}
              w porównaniu do ostatniego okresu
            </Skeleton>
          </Text>
        </Flex>
      </CardHeader>
      <Box w='100%' h={{ sm: "300px" }} ps='8px'>
      <Skeleton height={"100%"} isLoaded={percentage || percentage == 0}>
        {chart}
        </Skeleton>
      </Box>
    </Card>
  );
};

export default GlobalStats;
